function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".colorful-dot-grid_svg__a,.colorful-dot-grid_svg__e{fill:#614cb4;opacity:.8}.colorful-dot-grid_svg__e{fill:#f8c149}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-58 -97)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "colorful-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(58 97)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.5 97a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z",
  fill: "#188856",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "colorful-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 97)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(58 108)",
  fill: "#a9ddc3",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(69 108)",
  fill: "#ad9deb",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "colorful-dot-grid_svg__e",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 108)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.5 119a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z",
  fill: "#d98892",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("path", {
  className: "colorful-dot-grid_svg__e",
  d: "M72.5 119a3.5 3.5 0 11-3.5 3.5 3.5 3.5 0 013.5-3.5z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "colorful-dot-grid_svg__a",
  cx: 3.5,
  cy: 3.5,
  r: 3.5,
  transform: "translate(80 119)"
}));

function SvgColorfulDotGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 29",
    className: "w-full h-full"
  }, props), _ref, _ref2);
}

export default SvgColorfulDotGrid;